const fuseProvisioningDetailConstants = {
  PROVISIONING_DETAIL_LOADING: "PROVISIONING_DETAIL_LOADING",
  PROVISIONING_DETAIL_SUCCESS: "PROVISIONING_DETAIL_SUCCESS",
  PROVISIONING_DETAIL_FAILURE: "PROVISIONING_DETAIL_FAILURE",
};

const fuseGetConnectivityConstants = {
  FUSE_CHECK_CONNECTIVITY_LOADING: "FUSE_CHECK_CONNECTIVITY_LOADING",
  FUSE_CHECK_CONNECTIVITY_SUCCESS: "FUSE_CHECK_CONNECTIVITY_SUCCESS",
  FUSE_CHECK_CONNECTIVITY_FAILURE: "FUSE_CHECK_CONNECTIVITY_FAILURE",
};

const fuseGetConfigurationConstants = {
  FUSE_CHECK_CONFIGURATION_LOADING: "FUSE_CHECK_CONFIGURATION_LOADING",
  FUSE_CHECK_CONFIGURATION_SUCCESS: "FUSE_CHECK_CONFIGURATION_SUCCESS",
  FUSE_CHECK_CONFIGURATION_FAILURE: "FUSE_CHECK_CONFIGURATION_FAILURE",
};

const getRemoteRestartConstants = {
  GET_REMOTE_RESTART_LOADING: "GET_REMOTE_RESTART_LOADING",
  GET_REMOTE_RESTART_SUCCESS: "GET_REMOTE_RESTART_SUCCESS",
  GET_REMOTE_RESTART_FAILURE: "GET_REMOTE_RESTART_FAILURE",
};

export {
  fuseProvisioningDetailConstants,
  fuseGetConnectivityConstants,
  fuseGetConfigurationConstants,
  getRemoteRestartConstants,
};
